<template>
    <div class="confirmOrder">
        <CustomHeader leftText="订单详情" />
        <div v-if="orderDetail.status !== null" class="confirmOrder-wrap">
            <div class="process">
                <div>
                    <icon-bed />
                    <div>1.选择房型并预订</div>
                </div>
                <div>
                    <icon-wait-confirm />
                    <div>2.商家接单确认</div>
                </div>

                <div v-if="orderDetail.status == -2 && orderDetail.serviceStatus == -1">
                    <icon-svg color="#f85151" size="9vw" name="afterSale" />
                    <div style="color:#f85151;">
                        <span>3.</span>
                        <span>退订失败</span>
                    </div>
                </div>

                <div v-if="orderDetail.status == -2 && orderDetail.serviceStatus != -1">
                    <icon-svg color="#BFA66D" size="9vw" name="afterSale" />
                    <div>
                        <span>3.</span>
                        <span v-if="orderDetail.serviceStatus == 0">无售后信息</span>
                        <span v-if="orderDetail.serviceStatus == 1">退订</span>
                        <span v-if="orderDetail.serviceStatus == 2">客服审核</span>
                        <span v-if="orderDetail.serviceStatus == 3">卡券待退回</span>
                        <span v-if="orderDetail.serviceStatus == 4">退订成功</span>
                    </div>
                </div>

                <div v-if="orderDetail.status == -1">
                    <icon-svg color="#f85151" size="9vw" name="orderFail" />
                    <div style="color:#f85151;">3.预订失败</div>
                </div>

                <div v-if="orderDetail.status == 0">
                    <icon-svg name="waitConfirm" color="#BFA66D" />
                    <div>3.待处理</div>
                </div>

                <div v-if="orderDetail.status == 1">
                    <icon-svg name="ordering" color="#BFA66D" />
                    <div>3.处理中</div>
                </div>

                <div v-if="orderDetail.status == 2">
                    <icon-svg color="rgb(104, 191, 123)" name="orderSuccess" />
                    <div>3.预订成功</div>
                </div>

                <div v-if="orderDetail.status == 3">
                    <icon-svg color="rgb(104, 191, 123)" name="complete" />
                    <div>3.订单完成</div>
                </div>

                <div v-if="orderDetail.status == 4">
                    <icon-svg color="#f85151" size="9vw" name="orderFail" />
                    <div style="color:#f85151;">3.订单已作废</div>
                </div>
            </div>

            <div class="addressInfo" v-if="orderDetail.status == -1">
                <van-cell class="title" title="预定失败原因" value="" />
                <div class="content">
                    {{ orderDetail.failReason }}
                </div>
            </div>

            <div class="addressInfo" v-if="orderDetail.status == -2 && orderDetail.serviceStatus == -1">
                <van-cell class="title" title="退订失败" value="" />
                <div class="content">
                    {{ cusServiceObj.refuseReason }}
                </div>
            </div>

            <div class="addressInfo" v-if="orderDetail.status == -2">
                <van-cell class="title" title="申请退订原因" value="" />
                <div class="content">
                    {{ cusServiceObj.reason }}
                </div>
            </div>

            <div class="hotelInfo flex-column">
                <div class="roomTitle">
                    <div>{{ orderDetail.hotelName }}</div>
                    <div>{{ orderDetail.room.name }}</div>
                </div>
                <div class="tips">
                    <div class="ai-center">
                        <span class="fa fa-calendar mr-2"></span>
                        <span>{{ orderDetail.startLiveTime | toNumCNDate }}</span
                        >-
                        <span>{{ (orderDetail.startLiveTime + (orderDetail.liveCount || 0) * 24 * 60 * 60 * 1000) | toNumCNDate }}</span>
                        <span class="ml-2">住{{ orderDetail.liveCount }}晚</span>
                    </div>
                    <div>
                        <span style="font-size: 3.5vw;" class="fa fa-info-circle mr-2"></span>
                        <span>预定成功后不支持取消</span>
                    </div>
                </div>
            </div>

            <div class="addressInfo">
                <van-cell class="title" title="酒店地址" value="" />
                <div class="content">
                    {{ orderDetail.hotelAddress }}
                </div>
            </div>

            <div class="personInfo">
                <van-cell class="title" title="入住人信息" value="" />
                <van-form style="padding-bottom: 5px;">
                    <van-cell title="房间数量" :value="`${orderDetail.roomCount}间`" />
                    <van-cell v-for="(item, index) in orderDetail.residents.split(',')" :key="index" :title="`房间${index + 1}`" :value="item" />
                    <van-cell title="联系手机" :value="orderDetail.mobile" />
                </van-form>
            </div>

            <div class="detail">
                <van-cell
                    class="detailTitle"
                    title="明细"
                    :value="`${orderDetail.roomCount}间${orderDetail.liveCount}晚 共${orderDetail.liveCount * orderDetail.roomCount}次`"
                />
                <div class="jc-between detailItem" v-for="(item, index) in orderDetail.liveCount" :key="index">
                    <div>
                        <span>{{ (orderDetail.startLiveTime + index * 24 * 60 * 60 * 1000) | toYearMonthDate }}</span>
                        <!-- <span>无早餐</span> -->
                    </div>
                    <div>{{ orderDetail.liveCount }}间</div>
                </div>
            </div>

            <div class="orderNo">
                <van-cell title="订单号：" :value="orderDetail.id" />
                <van-cell title="创建时间：" :value="orderDetail.orderTime | toYMDHMS" />
            </div>

            <div v-if="orderDetail.status == 0 || orderDetail.status == 1" class="jc-center ai-center pv-2" @click="showReason">
                <div class="serviceBtn mr-3">
                    退订
                </div>
            </div>
        </div>
        <van-popup v-model="reasonVisible" round :style="{ height: '70vw' }">
            <div class="border-box ph-2 bg-white height-100 reasonContainer flex-center">
                <van-form @submit="onSubmit">
                    <van-field
                        name="reason"
                        v-model="reasonText"
                        rows="5"
                        autosize
                        label="退订原因"
                        type="textarea"
                        maxlength="100"
                        placeholder="请输入退订原因"
                        show-word-limit
                        :rules="[{ required: true }]"
                    />
                    <div class="pt-6 pb-2 ph-3">
                        <van-button :color="$primary" round block type="info" native-type="submit">提交</van-button>
                    </div>
                </van-form>
            </div>
        </van-popup>
    </div>
</template>
<script>
// import { searchParamsKey } from "@/utils/variable";
// import countryCodes from "@/utils/countryCode";
import IconSvg from "../../components/svg/IconSvg.vue";
import { getOrderDetail, getCusServiceObj, applyService } from "@/api/hotel";
const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime();
export default {
    components: { IconSvg },
    data() {
        return {
            orderDetail: {
                startLiveTime: Date.now(),
                endTime: Date.now() + 1000 * 60 * 60 * 24,
                liveCount: 1,
                roomCount: 1,
                roomNum: 2,
                residents: "",
                mobile: "",
                status: null,
                room: {},
                serviceStatus: 4,
            },
            reasonVisible: false,
            reasonText: "",
            cusServiceObj: {},
        };
    },
    created() {
        this.initPage();
    },
    methods: {
        onSubmit(formData) {
            applyService({ ...formData, orderid: this.orderDetail.id, type: 1 }).then(res => {
                if (res.code === 200) {
                    this.$toast.success("售后已提交");
                    this.initPage();
                    this.reasonVisible = false;
                } else {
                    this.$toast.success(res.msg || "提交失败");
                }
            });
        },
        initPage() {
            this.$toast.loading({ duration: 0, forbidClick: true, mask: true, message: "加载中..." });
            getOrderDetail(this.$route.query.orderId)
                .then(res => {
                    this.$toast.clear();
                    if (res.code === 200) {
                        this.orderDetail = res.data;
                        if (res.data.status == -2) {
                            getCusServiceObj({ orderid: res.data.id }).then(res1 => {
                                if (res1.code === 200) {
                                    this.cusServiceObj = res1.data;
                                }
                            });
                        }
                    } else {
                        this.$toast(res.data.msg);
                        setTimeout(() => {
                            this.$router.back();
                        }, 700);
                    }
                })
                .catch(err => {
                    this.$toast.fail("查询失败");
                    setTimeout(() => {
                        this.$router.back();
                    }, 700);
                });
        },
        showReason() {
            this.reasonVisible = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.confirmOrder-wrap {
    background-color: #ebeef5;
    height: calc(100vh - 46px);
    padding: 3vw;
    box-sizing: border-box;
    overflow-y: scroll;
    > div {
        border-radius: 1.2vw;
        overflow: hidden;
    }
    > div ~ div {
        margin-top: 3vw;
    }
    .process {
        height: 22vw;
        background-color: #fff;
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-shrink: 0;
        > div {
            width: 30%;
            position: relative;
            @extend .flex-column;
            justify-content: center;
            align-items: center;
            color: #6e6e6e;
            font-size: 3.2vw;
            > div:last-child {
                margin-top: 2vw;
                white-space: nowrap;
            }
        }
        div + div {
            &:before {
                content: "";
                background-color: rgba($color: #bfa66d, $alpha: 0.7);
                width: 7vw;
                height: 1px;
                position: absolute;
                left: -5vw;
                top: 25%;
            }
        }
    }
    .hotelInfo {
        padding: 1.5vw 2.7vw 0;
        box-sizing: border-box;
        background-color: #fff;
        display: flex;
        .roomTitle {
            font-size: 4vw;
            font-weight: bold;
            padding-bottom: 3vw;
            padding-top: 1.5vw;
            border-bottom: 1px solid #ececec;
        }
        .tips {
            padding: 2vw 0;
            color: #5a5a5a;
            font-size: 3vw;
            > div ~ div {
                margin-top: 1.5vw;
            }
        }
    }
    .addressInfo {
        background-color: #fff;
        .title {
            /deep/.van-cell__title {
                font-size: 4vw;
                font-weight: bold;
            }
        }
        .content {
            padding: 8px 16px;
            color: #5a5a5a;
        }
    }
    .personInfo {
        background-color: #fff;
        .title {
            /deep/.van-cell__title {
                font-size: 4vw;
                font-weight: bold;
            }
        }
        /deep/.van-cell__value {
            flex: 2;
            text-align: left;
            color: #000;
        }
    }
    .detail {
        background-color: #fff;
        padding-bottom: 3vw;
        .detailTitle {
            /deep/.van-cell__title {
                font-size: 4vw;
                font-weight: bold;
            }
        }
        .detailItem {
            font-size: 3.2vw;
            color: #6e6e6e;
            padding: 3px 16px;
        }
    }
    .serviceBtn {
        color: #969799;
        padding: 2vw 10vw;
        border-radius: 4vw;
        // background-color: #fbe3b3;
        border: 1px solid #ccc;
        font-size: 3.5vw;
        // box-shadow: 0 0 3px rgba($color: #000000, $alpha: 0.1);
        &:active {
            box-shadow: 0 0 6px rgba($color: #000000, $alpha: 0.1);
        }
    }
}
.reasonContainer {
    width: 64vw;
}
.noticeItem {
    font-size: 3.2vw;
    padding: 2vw 1.8vw 2vw 0;
    > div:first-child {
        width: 18vw;
        @extend .text-one;
        color: #000;
        font-weight: bold;
        margin-right: 2vw;
        text-align: right;
    }
    > div:last-child {
        flex: 1;
        color: #333;
    }
}
/deep/.van-index-bar__sidebar {
    top: 60%;
}
</style>
